.textLink {
  color: var(--pgm-sys-color-secondary);
  cursor: pointer;
  text-decoration: underline;
}

.textLink:hover,
.textLink:focus {
  text-decoration: underline;
  color: #0F443A;
  color: color-mix(
    in srgb,
    var(--pgm-sys-color-on-surface) 52%,
    var(--pgm-sys-color-secondary)
  );
}
